import {CategoryType} from './constants';
import {categoryIdRuleDefaults} from './defaults';
import {CategoryIdRule} from './types';

export type CategoryIdRuleParams<T extends CategoryType = CategoryType> = {
	id: number;
	type?: T;
};

export const createCategoryIdRule = ({
	id,
	type,
}: CategoryIdRuleParams): CategoryIdRule => ({
	...categoryIdRuleDefaults,
	elementSubType1: type != null ? type : categoryIdRuleDefaults.elementSubType1,
	elementValue1: id,
});

export default createCategoryIdRule;
